import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import VideoPlayer from '../../modal/VideoPlayer.modal';
var Overview = function Overview(_ref) {
  var showModalAction = _ref.showModalAction;
  return /*#__PURE__*/React.createElement("div", {
    className: "landingpage__overview",
    onMouseEnter: function onMouseEnter() {
      $('.landingpage__overview--ro').css({
        opacity: 1
      });
    },
    onMouseLeave: function onMouseLeave() {
      $('.landingpage__overview--ro').css({
        opacity: 0
      });
    },
    onClick: function onClick() {
      showModalAction({
        component: /*#__PURE__*/React.createElement(VideoPlayer, {
          url: "/public/images/Posillico-Wash-Plant-Overview.mp4"
        })
      });
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/landingpage/Posillico-Wash-Plant-Overview.png"
  }), /*#__PURE__*/React.createElement("div", {
    className: "landingpage__overview--ro"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/landingpage/Posillico-Wash-Plant-Overview-RO.png"
  })));
};
var mdtp = {
  showModalAction: modalActions.show
};
export default connect(null, mdtp)(Overview);